import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-84b13d30"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "name"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "text"
  }, "请留下您的联系方式，我们将尽快与您取得联系并提供帮助~", -1);
});
var _hoisted_3 = {
  "class": "group"
};
var _hoisted_4 = {
  "class": "input"
};
import Activity from '@/common/components/Activity.vue';
import { useNavigation } from '@/common/util/navigation';
import { useLoading } from '@/common/util/useLoading';
import { validator, validatorRule } from '@/common/util/validator';
import { getQueryParam } from '@/common/util/getUrlParam';
import { t } from '@/i18n';
import { postApiFeedbackMark } from '@/service/api';
import { getDictContactType, EnumContactType } from '@/util/dict';
import { feedbackInfoAction } from '@/util/event';
import { showSuccessToast } from 'vant';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _DictContactType$0$va, _DictContactType$;
    var handleFocus = function handleFocus() {
      setTimeout(function () {
        document.documentElement.scrollTop = document.body.scrollTop = 1000;
      }, 300);
    };
    var getQueryValue = function getQueryValue(key) {
      var paramValue = getQueryParam(key);
      if (paramValue) return paramValue;
      if (key === 'language' || key === 'region') {
        return window.sessionStorage.getItem("query:".concat(key)) || '';
      }
      return '';
    };
    var region = getQueryValue('region');
    var DictContactType = getDictContactType(region);
    var _useNavigation = useNavigation(),
      toBack = _useNavigation.toBack;
    var state = reactive({
      contactType: (_DictContactType$0$va = (_DictContactType$ = DictContactType[0]) === null || _DictContactType$ === void 0 ? void 0 : _DictContactType$.value) !== null && _DictContactType$0$va !== void 0 ? _DictContactType$0$va : EnumContactType.Email,
      contact: ''
    });
    var _useLoading = useLoading(),
      _useLoading2 = _slicedToArray(_useLoading, 2),
      loading = _useLoading2[0],
      handler = _useLoading2[1];
    var route = useRoute();
    var handleSubmit = function handleSubmit() {
      return handler(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validator(state, {
                contact: [['required', t('ContactCannotBeEmpty')]]
              });
            case 2:
              if (state.contactType === EnumContactType.Mobile) {
                validatorRule.mobile(state.contact, t('mobileInvalid'));
              }
              if (state.contactType === EnumContactType.Email) {
                validatorRule.email(state.contact, t('emailInvalid'));
              }
              _context.next = 6;
              return postApiFeedbackMark(_objectSpread({
                id: route.params.id,
                openId: window.openid,
                mark: 2
              }, state));
            case 6:
              showSuccessToast(t('OperationSuccessful'));
              feedbackInfoAction.emit('close');
              toBack();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    };
    return function (_ctx, _cache) {
      var _component_van_radio = _resolveComponent("van-radio");
      var _component_van_radio_group = _resolveComponent("van-radio-group");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createBlock(Activity, {
        "class": "FeedbackInfoFailView"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('submitSuccess')), 1), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_radio_group, {
            modelValue: _unref(state).contactType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _unref(state).contactType = $event;
            }),
            direction: "horizontal"
          }, {
            "default": _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DictContactType), function (item) {
                return _openBlock(), _createBlock(_component_van_radio, {
                  name: item.value
                }, {
                  "default": _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item.label), 1)];
                  }),
                  _: 2
                }, 1032, ["name"]);
              }), 256))];
            }),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
            placeholder: _unref(t)('contactPlaceholder'),
            modelValue: _unref(state).contact,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _unref(state).contact = $event;
            }),
            onFocus: handleFocus
          }, null, 8, ["placeholder", "modelValue"])]), _createVNode(_component_van_button, {
            type: "primary",
            "class": "button",
            loading: _unref(loading),
            block: "",
            onClick: handleSubmit
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)('submit')), 1)];
            }),
            _: 1
          }, 8, ["loading"])];
        }),
        _: 1
      });
    };
  }
});